import React, { useState, useEffect, useContext } from 'react';
import AppBar from '../../components/AppBar';
import Footer from '../../components/Footer';
import './WithdrawEarnings.css';
import BinanceIcon from '../../assets/binance.png';
import TetherIcon from '../../assets/tether.png';
import { APP_CONFIG } from '../../config/appConfig';
import { useNavigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import tracker from '../../utils/tracker';



const WithdrawEarnings = () => {
  const navigate = useNavigate();
  const { user, loading: authLoading } = useContext(AuthContext);
  const [amount, setAmount] = useState('');
  const [address, setAddress] = useState('');
  const [showSuccess, setShowSuccess] = useState(false);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const { reportActivity } = useContext(AuthContext);
  
  const location = useLocation();


  useEffect(() => {
    // Wait until auth state is resolved
    if (!authLoading && !user) {
      navigate('/login', { replace: true });
    }
  }, [authLoading, user, navigate]);

  const minimumAmount = 50;
  const isValidAmount = amount && parseFloat(amount) >= minimumAmount;
  const isValidAddress = address && address.length > 20;

  const handleRequest = async () => {
    if (!isValidAmount || !isValidAddress) return;
      reportActivity(location.pathname);
      tracker.track('cta_click', { cta: 'withdraw_submit' });


    setLoading(true);

    try {
      const response = await fetch(`${APP_CONFIG.API_BASE_URL}/withdraw/request`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          amount: parseFloat(amount),
          address: address.trim()
        })
      });

      const data = await response.json();

      if (!response.ok) {
        setErrorMessage(data.error || 'Withdrawal request failed');
        setShowErrorPopup(true);
        return;
      }

      setShowSuccess(true);
      setTimeout(() => {
        setShowSuccess(false);
        setAmount('');
        setAddress('');
      }, 3000);

    } catch (error) {
      console.error('Withdrawal request error:', error);
      setErrorMessage('Failed to process withdrawal request');
      setShowErrorPopup(true);
    } finally {
      setLoading(false);
    }
  };

  const handlePopupOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      setShowSuccess(false);
    }
  };

  return (
    <div>
      <AppBar />
      <div style={{ height: '100px' }} />

      {showErrorPopup && (
        <div className="popup-overlay" onClick={handlePopupOverlayClick}>
          <div className="popup">
            <button className="popup-close" onClick={() => setShowErrorPopup(false)}>×</button>
            <p>{errorMessage}</p>
          </div>
        </div>
      )}

      {showSuccess && (
        <div className="popup-overlay" onClick={handlePopupOverlayClick}>
          <div className="popup">
            <button className="popup-close" onClick={() => setShowSuccess(false)}>×</button>
            <p>Withdrawal request submitted successfully!</p>
          </div>
        </div>
      )}

      <div className="withdraw-page">
        <h1 className="withdraw-title">Withdraw Funds</h1>

        <div className="withdraw-container">
          <div className="withdraw-section">
            <label className="withdraw-label">Withdrawal Amount</label>
            <div className="withdraw-input-wrapper">
              <span className="withdraw-currency">$</span>
              <input
                type="number"
                className="withdraw-input"
                placeholder="0.00"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                min={minimumAmount}
                step="0.01"
              />
            </div>
            <div className="withdraw-note">Minimum withdrawal amount: ${minimumAmount}</div>
          </div>

          <div className="withdraw-divider" />

          <div className="withdraw-section">
            <label className="withdraw-label">Payment Method</label>
            
            <div className="withdraw-payment-row">
              <div className="withdraw-payment-item">
                <div className="withdraw-payment-header">Blockchain</div>
                <div className="withdraw-crypto-box">
                  <img src={BinanceIcon} alt="Binance" className="withdraw-crypto-icon" />
                  <div className="withdraw-crypto-details">
                    <span className="withdraw-crypto-name">Binance Smart Chain</span>
                    <span className="withdraw-crypto-network">BEP-20 Network</span>
                  </div>
                </div>
              </div>

              <div className="withdraw-payment-item">
                <div className="withdraw-payment-header">Coin</div>
                <div className="withdraw-crypto-box">
                  <img src={TetherIcon} alt="USDT" className="withdraw-crypto-icon" />
                  <div className="withdraw-crypto-details">
                    <span className="withdraw-crypto-name">USDT</span>
                    <span className="withdraw-crypto-network">Tether USD</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="withdraw-note">
              Transaction fees may apply and will be deducted from the payout amount
            </div>
          </div>

          <div className="withdraw-divider" />

          <div className="withdraw-section">
            <label className="withdraw-label">Wallet Address</label>
            <input
              type="text"
              className="withdraw-input withdraw-address-input"
              placeholder="Enter your BEP-20 wallet address"
              value={address}
              onChange={(e) => setAddress(e.target.value)}
            />
            <div className="withdraw-note">
              Make sure the address is correct. Funds sent to wrong addresses cannot be recovered.
            </div>
          </div>

          <button
            className="withdraw-button"
            onClick={handleRequest}
            disabled={!isValidAmount || !isValidAddress || loading}
          >
            {loading ? 'Processing...' : 'Request Withdrawal'}
          </button>
        </div>
      </div>

      {loading && (
        <div className="withdraw-loading-overlay">
          <div className="withdraw-spinner"></div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default WithdrawEarnings;